import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import Swal from 'sweetalert2';

//import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import TaskItem from '@/views/TrainingCamp/TrainingCamp/components/TaskItem.vue';

import MainModeBook from '@/scripts/MainMode/MainModeBook/MainModeBook';
import {
  TrainingCampRouteInfoMixin
} from '@/scripts/TrainingCamp/TrainingCamp/mixins/TrainingCampRouteInfoMixin';

import { LOADING_MESSAGE } from './TrainingCamp.constants';

// TrainingCampRouteInfoMixin
const GetCourseTaskInfoMixin = {
  name: 'GetCourseTaskInfoMixin',

  data() {
    return {
      promiseGetCourseTaskInfo: null,
    };
  },

  methods: {
    ...mapActions('TrainingCamp/TrainingCamp', {
      ma_getCourseTaskInfo: 'getCourseTaskInfo',
      ma_getPersonalTaskInfo: 'getPersonalTaskInfo',
    }),

    getCourseTaskInfo() {
      let getCourseTaskInfo;
      if (this.c_isTrainingCampPersonalPage) {
        getCourseTaskInfo = this.ma_getPersonalTaskInfo;
      } else {
        getCourseTaskInfo = this.ma_getCourseTaskInfo;
      }
      this.promiseGetCourseTaskInfo = getCourseTaskInfo({
        courseId: this.c_taskId,
      });
    },
  },

  created() {
    this.getCourseTaskInfo();
  },
};

// TrainingCampRouteInfoMixin
const CourseTaskInfoMixin = {
  name: 'CourseTaskInfoMixin',

  computed: {
    ...mapGetters('TrainingCamp/TrainingCamp', {
      mg_courseTaskInfo: 'courseTaskInfo',
    }),

    c_courseTaskInfo() {
      return {
        ...this.mg_courseTaskInfo,
        taskList: _.map(this.mg_courseTaskInfo.taskList, (task) => {
          let c_currentTask = false;
          //if (this.c_isTrainingCampPage && 0 === taskIdx) {
          //  c_currentTask = true;
          //}
          if (/* this.c_isTrainingCampPersonalPage && */ task.currentTask) {
            c_currentTask = true;
          }
          return {
            ...task,
            c_currentTask,
          };
        }),
      };
    },
  },
};

// MainModeBook
// TrainingCampRouteInfoMixin, CourseTaskInfoMixin
const CheckAndAddCourseTaskMixin = {
  name: 'CheckAndAddCourseTaskMixin',

  computed: {
    ...mapState('TrainingCamp/TrainingCamp', {
      ms_res_checkAndAddCourseTask: 'res_checkAndAddCourseTask',
    }),

    c_isShowCheckAndAddCourseTask() {
      return this.c_isTrainingCampPage && !this.c_courseTaskInfo.alreadyInClass;
    },
  },

  methods: {
    ...mapActions('TrainingCamp/TrainingCamp', {
      //ma_checkAndAddCourseTask: 'checkAndAddCourseTask',
      ma_addByClassidCourseTask: 'addByClassidCourseTask',
    }),

    async checkAndAddCourseTask() {
      await this.ma_addByClassidCourseTask({
        courseId: this.c_taskId,
      });
      if (1 !== this.ms_res_checkAndAddCourseTask.checkResult) {
        //Swal.fire({
        //  width: '400px',
        //  backdrop: false,
        //  icon: 'warning',
        //  title: `报名失败`,
        //  text: this.ms_res_checkAndAddCourseTask.checkMessage,
        //  //showConfirmButton: false,
        //  timer: 3000,
        //});
        $(this.$refs.modalAddCourseTask).modal('show');
      } else {
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'success',
          title: `报名成功`,
          text: '恭喜你成功加入魔鬼训练营！',
          //showConfirmButton: false,
          timer: 3000,
        });
      }
    },
  },

  created() {
    this.checkAndAddCourseTask = this.checkClassRestrictionAndDoFunc(this.checkAndAddCourseTask);
  },
};

// TrainingCampRouteInfoMixin, GetCourseTaskInfoMixin, CourseTaskInfoMixin
const GotoCurrentTaskMixin = {
  name: 'GotoCurrentTaskMixin',

  computed: {
    c_isShowBtnCurrentTask() {
      return this.c_isTrainingCampPersonalPage && this.c_courseTaskInfo.taskList.length;
    },

    c_isNoPersonalCurrentTask() {
      const currentTaskList = _.filter(
        this.c_courseTaskInfo.taskList, (task) => task.c_currentTask
      );
      return this.c_isTrainingCampPersonalPage && 0 === currentTaskList.length;
    },
  },

  methods: {
    gotoCurrentTask() {
      this.$scrollTo('#current-task', 500, {
        container: 'main',
        easing: 'linear',
        offset: -75,
      });
    },

    async GotoCurrentTaskMixinMounted() {
      await this.promiseGetCourseTaskInfo;
      if (this.c_isTrainingCampPersonalPage && !this.c_isNoPersonalCurrentTask) {
        this.gotoCurrentTask();
      }
    },
  },

  mounted() {
    this.GotoCurrentTaskMixinMounted();
  },
};

// MainModeBook
const SelectedBulletMixin = {
  name: 'SelectedBulletMixin',

  computed: {
    ...mapState('TrainingCamp/TrainingCamp', {
      ms_selectedBulletId: 'selectedBulletId',
    }),

    c_idxSelectedBullet() {
      return _.findIndex(
        this.ReadyToPlayVideos, (v) => this.ms_selectedBulletId === v.bulletId
      );
    },

    c_selectedBullet() {
      const selectedBullet = this.ReadyToPlayVideos[this.c_idxSelectedBullet];
      return selectedBullet ? selectedBullet : {};
    },

    c_nextBullet() {
      const nextVideo = this.ReadyToPlayVideos[this.c_idxSelectedBullet + 1];
      return nextVideo ? nextVideo : {};
    },
  },

  methods: {
    ...mapMutations('TrainingCamp/TrainingCamp', {
      mm_SET_SELECTED_BULLET_ID: 'SET_SELECTED_BULLET_ID',
    }),

    ///
    openPlayer(bullet) {
      this.mm_SET_SELECTED_BULLET_ID(bullet.bulletId);
      this.isShowPlayer = true;
    },
  },

  created() {
    this.mm_SET_SELECTED_BULLET_ID(-1);
  },
};

// MainModeBook
const GeneratePDFMixin = {
  name: 'GeneratePDFMixin',

  methods: {
    ...mapMutations('TrainingCamp/TrainingCamp', {
      mm_SET_SELECTED_FILE_ID: 'SET_SELECTED_FILE_ID',
    }),

    ...mapActions('TrainingCamp/TrainingCamp', {
      ma_generateFile: 'generateFile',
    }),

    async generatePDF(taskId, bookId, fileId) {
      this.mm_SET_SELECTED_FILE_ID(fileId);
      await this.ma_generateFile({
        courseId: this.CourseId,
        taskId,
        bookId,
        fileId,
      });
      this.mm_SET_SELECTED_FILE_ID(-1);
    },
  },

  created() {
    this.generatePDF = this.checkClassRestrictionAndDoFunc(this.generatePDF);
    this.mm_SET_SELECTED_FILE_ID(-1);
  },
};

export default {
  name: 'TrainingCamp',

  mixins: [
    //
    MainModeBook,
    TrainingCampRouteInfoMixin,
    GetCourseTaskInfoMixin,
    CourseTaskInfoMixin,
    CheckAndAddCourseTaskMixin,
    GotoCurrentTaskMixin,
    SelectedBulletMixin,
    GeneratePDFMixin,
  ],

  components: {
    //WayFindBar,
    ToolBar,
    Footer,
    Spinner,
    TaskItem,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('TrainingCamp/TrainingCamp', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters('TrainingCamp/TrainingCamp', {
      mg_ReadyToPlayVideos: 'ReadyToPlayVideos',
      mg_subjectPoints: 'subjectPoints',
    }),

    ///
    CourseId() {
      return this.c_courseTaskInfo.courseId;
    },

    c_isQuestionLibAvailable() {
      return 1 === this.c_courseTaskInfo.questionLibStatus;
    },

    ///
    ReadyToPlayVideos() {
      return _.map(this.mg_ReadyToPlayVideos, (bulletVideo) => ({
        ...bulletVideo,
        courseId: this.c_taskId,
      }));
    },

    ///
    c_restrictStudent() {
      return this.c_courseTaskInfo.restrictStudent;
    },
  },

  methods: {
    ...mapMutations('TrainingCamp/TrainingCamp', {
      mm_SET_SELECTED_BULLET_ID: 'SET_SELECTED_BULLET_ID',
      mm_UPDATE_BULLET_SUBJECT: 'UPDATE_BULLET_SUBJECT',
    }),

    ///
    goToNextVideo() {
      this.mm_SET_SELECTED_BULLET_ID(this.c_nextBullet.bulletId);
    },

    ///
    changeBulletStatus(video, bulletStatus) {
      this.mm_UPDATE_BULLET_SUBJECT({
        video,
        payload: {
          bulletStatus,
        },
      });
    },

    ///
    setLastProgress(videoId, payload) {
      const video = _.find(this.ReadyToPlayVideos, (video) => videoId === video.videoId);
      this.mm_UPDATE_BULLET_SUBJECT({ video, payload });
    },

    ///
    go2Practice(subject) {
      let noQuestionLibMessage = this.c_courseTaskInfo.noQuestionLibMessage;
      noQuestionLibMessage = noQuestionLibMessage ?
        noQuestionLibMessage : '您当前的班型没有此功能的权限，可补差价升级后开启!';
      if (!this.c_isQuestionLibAvailable) {
        Swal.fire({
          width: '400px',
          icon: 'info',
          title: `非考证班无法参加挑战`,
          text: noQuestionLibMessage,
          showConfirmButton: true,
          confirmButtonText: '知道啦',
        });
        return;
      }
      this.isShowPractice = true;
      this.questionTitle = `${subject.subjectName}练习`;
      this.currentSubjectId = subject.subjectId;
      this.getBeforePractice({ subjectId: subject.subjectId });
    },

    ///
    closePractice() {
      if (this.AfterPracticeData && this.AfterPracticeData.afterSubject) {
        const subject = _.find(
          this.mg_subjectPoints,
          (subject) => this.currentSubjectId === subject.subjectId
        );
        this.mm_UPDATE_BULLET_SUBJECT({
          subject,
          payload: {
            totalPoint: this.AfterPracticeData.afterSubject.totalPoints,
            currentPoint: this.AfterPracticeData.afterSubject.currentPoints,
            layerLevel: this.AfterPracticeData.afterSubject.pointsReachLevel,
          },
        });
      }
      this.isShowPractice = false;
      this.clearPracticeData();
    },

    ///
    retryPractice() {
      this.clearPracticeData();
      this.getPracticeData();
    },

    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = this.promiseGetCourseTaskInfo;
    },

    ///
    ClassChineseFrmMixinCreated() {
      //
    },

    ///
    _mainModeBookCreated() {
      //
    },

    ///
    _mainModeBookMounted() {
      //
    },

    ///
    _mainModeBookBeforeDestroy() {
      //
    },
  },
};
